export default __webpack_public_path__ + "static/media/p-minus-3.f85e5fd2.svg";